<template>
  <div>
    <a
      :href="topBanner.href"
      class="header__top-banner"
      :style="topBanner.gradient"
      target="_blank"
      v-if="topBanner"
    >
      <div class="header__top-banner-row">
        <div class="header__top-banner-tag" v-html="topBanner.tag"></div>
        <div class="header__top-banner-title" v-html="topBanner.title"></div>
        <div class="header__top-banner-link" v-html="topBanner.href_text"></div>
      </div>
    </a>

    <div class="main-wrapper">
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Onest:wght@100..900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap"
        rel="stylesheet"
      />

      <header class="header">
        <div class="content">
          <div class="header__row">
            <div class="header__logo">
              <img
                :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/zokus/logo.svg`"
              />
            </div>
            <div class="header__tools">
              <a href="/medication/betalok" class="header__back">
                На главную
              </a>
              <div class="header__mute" @click="toggleMute()">
                <svg
                  v-if="!mute"
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.28809 0.0332031C8.39509 -0.0250281 8.67923 -0.00246488 8.7793 0.0722656C8.89347 0.157559 8.96387 0.262485 8.99414 0.392578C9.02961 0.545644 9.02961 13.4524 8.99414 13.6055C8.9408 13.8355 8.77789 13.9777 8.54492 13.9971C8.43162 14.0064 8.3596 13.995 8.28809 13.958C8.23128 13.928 7.09961 13.0341 5.77148 11.9697L3.35449 10.0322L0.776367 10.0029L0.591797 9.91797C0.360472 9.81106 0.145436 9.58423 0.0605469 9.35742C0.00116929 9.1987 0 9.14798 0 6.99902C8.41296e-08 4.85166 0.00128458 4.80008 0.0605469 4.6416C0.14541 4.41468 0.36035 4.18699 0.591797 4.08008L0.776367 3.99512L3.35449 3.96582L5.7832 2.01953C7.11741 0.950785 8.24358 0.0582941 8.28809 0.0332031ZM12.377 1.94629C12.4852 1.89 12.6553 1.88675 12.7803 1.93945C12.8321 1.96132 12.969 2.07716 13.085 2.19629C13.9476 3.08277 14.5792 4.26958 14.8477 5.50879C14.9893 6.16299 15.0386 7.0933 14.9668 7.75488C14.8045 9.25018 14.1465 10.6863 13.1396 11.7412C12.994 11.8939 12.8323 12.0365 12.7803 12.0586C12.4915 12.1799 12.1448 11.9883 12.0859 11.6748C12.051 11.4884 12.111 11.3593 12.3652 11.082C13.4456 9.90375 13.9727 8.5654 13.9727 6.99902C13.9726 6.43824 13.9222 6.01039 13.7988 5.52344C13.5514 4.54691 13.0878 3.69913 12.3799 2.93066C12.1133 2.64126 12.047 2.50708 12.085 2.33008C12.1252 2.1429 12.2083 2.03427 12.377 1.94629ZM10.9551 3.37305C11.107 3.29625 11.2455 3.28924 11.377 3.35156C11.5964 3.45573 12.1144 4.08316 12.3867 4.57617C13.3052 6.23922 13.1906 8.34586 12.0996 9.87305C11.7116 10.4161 11.4026 10.6898 11.1738 10.6914C11.045 10.6921 10.8345 10.5749 10.7588 10.4609C10.5969 10.2168 10.6411 10.0204 10.9297 9.70215C11.4327 9.14742 11.7496 8.52911 11.9111 7.78906C11.9877 7.43814 11.9876 6.5612 11.9111 6.20996C11.7496 5.46975 11.4329 4.85072 10.9297 4.2959C10.8035 4.15677 10.7108 4.02573 10.6895 3.95508C10.6212 3.72711 10.7314 3.48611 10.9551 3.37305Z"
                    fill="currentColor"
                  />
                </svg>

                <svg
                  v-else
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.01758 8.49902C9.01526 11.1958 9.00914 13.5407 8.99414 13.6055C8.9408 13.8355 8.77789 13.9777 8.54492 13.9971C8.43162 14.0064 8.3596 13.995 8.28809 13.958C8.23128 13.928 7.09961 13.0341 5.77148 11.9697L3.35449 10.0322L0.776367 10.0029L0.591797 9.91797C0.360472 9.81106 0.145436 9.58423 0.0605469 9.35742C0.00116929 9.1987 0 9.14798 0 6.99902C8.41296e-08 4.85166 0.00128458 4.80008 0.0605469 4.6416C0.14541 4.41468 0.36035 4.18699 0.591797 4.08008L0.776367 3.99512L3.35449 3.96582L4.00391 3.44434L9.01758 8.49902ZM12.582 12.0928C12.351 12.0858 12.1317 11.9183 12.0859 11.6748C12.08 11.6429 12.077 11.6126 12.0771 11.583L12.582 12.0928ZM12.377 1.94629C12.4852 1.89 12.6553 1.88675 12.7803 1.93945C12.8321 1.96132 12.969 2.07716 13.085 2.19629C13.9476 3.08277 14.5792 4.26958 14.8477 5.50879C14.9893 6.16299 15.0386 7.0933 14.9668 7.75488C14.8157 9.1473 14.2341 10.4878 13.3418 11.5176L12.6182 10.7881C13.527 9.6818 13.9727 8.4371 13.9727 6.99902C13.9726 6.43824 13.9222 6.01039 13.7988 5.52344C13.5514 4.54691 13.0878 3.69913 12.3799 2.93066C12.1133 2.64126 12.047 2.50708 12.085 2.33008C12.1252 2.1429 12.2083 2.03427 12.377 1.94629ZM11.1895 10.6885C11.1843 10.6888 11.1789 10.6914 11.1738 10.6914C11.045 10.6921 10.8345 10.5749 10.7588 10.4609C10.69 10.3573 10.6595 10.2625 10.668 10.1631L11.1895 10.6885ZM10.9551 3.37305C11.107 3.29625 11.2455 3.28924 11.377 3.35156C11.5964 3.45573 12.1144 4.08316 12.3867 4.57617C13.3052 6.23922 13.1906 8.34586 12.0996 9.87305C12.0421 9.95362 11.9857 10.028 11.9316 10.0967L11.2041 9.36328C11.5497 8.89628 11.7816 8.38275 11.9111 7.78906C11.9877 7.43814 11.9876 6.5612 11.9111 6.20996C11.7496 5.46975 11.4329 4.85072 10.9297 4.2959C10.8035 4.15677 10.7108 4.02573 10.6895 3.95508C10.6212 3.72711 10.7314 3.48611 10.9551 3.37305ZM8.28809 0.0332031C8.39509 -0.0250281 8.67923 -0.00246488 8.7793 0.0722656C8.89347 0.157559 8.96387 0.262485 8.99414 0.392578C9.01217 0.470376 9.01983 3.84318 9.01953 7.16113L4.74414 2.85156L5.7832 2.01953C7.11741 0.950785 8.24358 0.0582941 8.28809 0.0332031Z"
                    fill="currentColor"
                  />
                  <path
                    d="M0.90625 1.04688L12.8791 13.1155"
                    stroke="currentColor"
                    stroke-width="0.94382"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </header>

      <router-view :mute="mute" :key="quizKey" @refreshQuiz="refreshQuiz" />
      <section class="before-footer">
        <div class="content">
          <div class="before-footer__shorts">
            ЧСС — частота сердечных сокращений, АД — артериальное давление, ИБС
            — ишемическая болезнь сердца, ФК — функциональный класс, АПФ —
            ангиотензинпревращающий фермент, АБ — бета-адреноблокаторы,ДГП-БКК —
            дигидропиридиновые блокаторы «медленных» кальциевых каналов
            <br />
            <br />
            Источники:
            <ol>
              <li>
                Стабильная ишемическая болезнь сердца. Клинические рекомендации
                2024. Российский кардиологический журнал. 2024; 29(9): 6110.
              </li>
              <li>
                Общая характеристика лекарственного препарата Беталок® ЗОК
                (метопролола сукцинат таблетки с пролонгированным
                высвобождением, покрытые оболочкой, 25 мг, 50 мг, 100 мг).
                Регистрационное удостоверение ЛП-Nº(002842)-(РГ-RU) от
                07.08.2024.
              </li>
              <li>Sanberg A. et al, Clin Pharmacol 1990; 30: S2-S16.</li>
              <li>
                Sandberg A, Blomqvist I, Jonsson UE, et al. Pharmacokinetic and
                pharmacodynamic properties of a new controlled-release
                formulation of metoprolol: a comparison with conventional
                tablets. Eur J Clin Pharmacol. 1988; 33 (Suppl.): S9-14.
              </li>
              <li>
                Бубнова М.Г. Место В-адреноблокаторов в лечении
                сердечно-сосудистых заболеваний с позиции современных
                рекомендаций: в фокусе метопролола сукцинат CR/XL. Cardio. 2022;
                13 (1).
              </li>
              <li>
                Kendall M.J. Journal of Clinical Pharmacy and Therapeutics,
                1989;14,159-179.
              </li>
              <li>
                Jansson S-O., Malm A.E., Lundstrom T. Drugs RD (2014)
                14:325-332.
              </li>
              <li>
                Полосьянц О. Б. Бета-адреноблокаторы-классика фармакологии в
                лечении артериальной гипертензии //РМЖ. – 2009. – Т. 17. – №. 8.
                – С. 595-599.
              </li>
              <li>Bongers et al Clin Drug Invest 1999 Feb; 17(2):103-110.</li>
            </ol>
            <br />
            <br />
            Номер одобрения: RU-24557 Дата одобрения: 16.04.2025 Дата истечения:
            15.04.2027
          </div>
        </div>
      </section>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import { mapGetters } from 'vuex';
export default {
  name: "BetalockLab",
  components: {
    Footer,
  },
  data: () => ({
    mute: false,
    quizKey: 0,
  }),
  computed: {
    ...mapGetters(['topBanner'])
  },
  methods: {
    toggleMute() {
      this.$set(this, "mute", !this.mute);
    },
    refreshQuiz() {
      this.$set(this, "quizKey", this.quizKey + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  position: relative;
  height: 100vh;
}

.header {
  padding: 14px 0;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;

  &__top-banner {
    display: block;
    padding: 4px 16px;
    &-row {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;
      @media screen and (max-width: 1220px) {
        gap: 16px;
      }
      @media screen and (max-width: 767px) {
        flex-direction: column;
        gap: 8px;
      }
    }

    &-title {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      text-align: center;
      @media screen and (max-width: 1220px) {
        font-size: 14px;
      }
    }
    &-link {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      text-decoration-line: underline;
      color: #08bef8;
      @media screen and (max-width: 1220px) {
        font-size: 14px;
      }
    }
  }

  &__logo {
    & img {
      max-width: 100%;
    }
    @media screen and (max-width: 767px) {
      width: 120px;
    }
  }

  &__row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__tools {
    margin-left: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
  }

  &__back {
    padding: 8px 16px;
    font-family: "Onest", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: #ffffff;
    transition: 0.3s;
    cursor: pointer;
    border: 1px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: #fff;
      color: #3f0d50;
    }
  }

  &__mute {
    width: 34px;
    height: 34px;
    color: #ffffff;
    transition: 0.3s;
    cursor: pointer;
    border: 1px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    & svg {
      flex-shrink: 0;
    }

    &:hover {
      background-color: #fff;
      color: #3f0d50;
    }
  }
}

.before-footer {
  padding: 20px 0;
  background-color: #1f1f1f;
  color: #b9b9b9;

  &__shorts {
    font-family: "Raleway", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 110%;

    & ol {
      margin-top: 12px;
      list-style-type: decimal;
      margin-left: 1em;

      & li {
        &:not(:last-child) {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>